export class Address {
	public state: string
	public city: string
	public street: string
	public cep: string
	public lat: number
	public lng: number
}

// Padronizar para "lat" e "lng" depois
export class CompanyAddress {
	public state: string
	public city: string
	public street: string
	public cep: string
	public coordinatesLat: number
	public coordinatesLng: number
}
